<template>
  <div class="business-page">
    <Header />
    <!-- Banner -->
    <div class="business-banner cloud-banner">
      <div class="banner-content">
        <h1 class="banner-title">云服务业务</h1>
        <p class="banner-subtitle">全场景数字化解决方案，赋能企业全链路数字化升级</p>
      </div>
    </div>

    <!-- 四大云服务 Tab -->
    <div class="business-section">
      <div class="section-container">
        <div class="tab-container">
          <div
            v-for="(tab, index) in cloudTabs"
            :key="index"
            class="tab-item"
            :class="{ active: activeTabIndex === index }"
            @click="activeTabIndex = index"
          >
            {{ tab.name }}
          </div>
        </div>
        <div class="tab-content">
          <div class="content-header">
            <h2 class="content-title">{{ cloudTabs[activeTabIndex].name }}</h2>
            <p class="content-desc">{{ cloudTabs[activeTabIndex].desc }}</p>
          </div>
          <div class="product-grid">
            <div
              v-for="(product, pIndex) in cloudTabs[activeTabIndex].products"
              :key="pIndex"
              class="product-card"
            >
              <div class="product-icon">{{ product.icon }}</div>
              <div class="product-name">{{ product.name }}</div>
              <div class="product-detail">{{ product.detail }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 联系我们 -->
    <div class="business-section section-gray">
      <div class="section-container">
        <div class="contact-card">
          <h3 class="contact-title">联系我们</h3>
          <p class="contact-desc">了解更多云服务产品，获取专属解决方案</p>
          <button class="primary-btn">立即咨询</button>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import metaInfo from "@/common/util/metaInfo";

export default {
  name: 'BusinessCloud',
  metaInfo: metaInfo.cloud,
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      activeTabIndex: 0,
      cloudTabs: [
        {
          name: '千橙零售云',
          desc: '零售门店数智化升级，助力经营增收提效',
          products: [
            { name: '千橙ERP系统', detail: '到店/到家交易业务管理', icon: '📊' },
            { name: '千橙收银系统', detail: '半自动/自助一体机收单', icon: '💰' },
            { name: '千橙连锁系统', detail: '支持直营/联营/加盟多业态', icon: '🏪' },
            { name: '千橙新零售系统', detail: '门店O2O一体化综合管理', icon: '🔄' },
            { name: '汇团团社群营销系统', detail: '社群团购分享小程序系统', icon: '👥' },
            { name: '千橙微商城系统', detail: '社群电商小程序系统', icon: '🛒' },
            { name: '千橙会员营销系统', detail: '基于会员的SCRM系统', icon: '👤' }
          ]
        },
        {
          name: '千橙云',
          desc: '全链路电商能力覆盖，支持多种电商模式落地',
          products: [
            { name: '千橙S2B2C系统', detail: '全链路全闭环交易系统', icon: '🔗' },
            { name: '千橙B2B分销系统', detail: '批发渠道多层级分销系统', icon: '📦' },
            { name: '汇好看直播系统', detail: '视频号+小程序直播系统', icon: '📹' }
          ]
        },
        {
          name: '千橙服务云',
          desc: 'AI+新场景，提升运营服务效率',
          products: [
            { name: '千橙RPA工具箱', detail: '机器人流程自动化服务', icon: '🤖' },
            { name: '千橙数字人', detail: 'AI数字人直播助手', icon: '👤' }
          ]
        },
        {
          name: '千橙分销云',
          desc: '打造"连接"+"提效"+"交易"的一站式智能分销平台',
          products: [
            { name: '千橙分销', detail: '基于企微的业务员分销系统', icon: '📤' }
          ]
        }
      ]
    };
  },
  methods: {}
};
</script>

<style lang="less" scoped>
.business-page {
  width: 100%;
}

.business-banner {
  width: 100%;
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #1763FF 0%, #3986FF 100%);
}

.cloud-banner {
  background: linear-gradient(135deg, #0A4A8A 0%, #1763FF 100%);
}

.banner-content {
  text-align: center;
  color: #FFFFFF;
}

.banner-title {
  font-size: 48px;
  font-weight: bold;
  margin-bottom: 20px;
}

.banner-subtitle {
  font-size: 20px;
  opacity: 0.9;
}

.business-section {
  padding: 80px 0;
}

.section-gray {
  background: #F8F9FA;
}

.section-container {
  width: 1200px;
  margin: 0 auto;
}

.tab-container {
  display: flex;
  gap: 8px;
  border-bottom: 2px solid #E5E5E5;
  margin-bottom: 50px;
}

.tab-item {
  padding: 16px 32px;
  font-size: 18px;
  color: #595859;
  cursor: pointer;
  position: relative;
  transition: color 0.3s;
}

.tab-item:hover {
  color: #1763FF;
}

.tab-item.active {
  color: #1763FF;
  font-weight: 600;
}

.tab-item.active::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  right: 0;
  height: 2px;
  background: #1763FF;
}

.tab-content {
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

.content-header {
  text-align: center;
  margin-bottom: 50px;
}

.content-title {
  font-size: 36px;
  font-weight: 600;
  color: #222222;
  margin-bottom: 16px;
}

.content-desc {
  font-size: 18px;
  color: #595859;
}

.product-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

.product-card {
  padding: 30px 20px;
  background: #F8F9FA;
  border-radius: 8px;
  text-align: center;
  transition: all 0.3s;
}

.product-card:hover {
  background: #FFFFFF;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.08);
  transform: translateY(-4px);
}

.product-icon {
  font-size: 40px;
  margin-bottom: 16px;
}

.product-name {
  font-size: 16px;
  font-weight: 600;
  color: #222222;
  margin-bottom: 8px;
}

.product-detail {
  font-size: 12px;
  color: #595859;
  line-height: 18px;
}

.contact-card {
  padding: 60px;
  background: #FFFFFF;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
}

.contact-title {
  font-size: 32px;
  font-weight: 600;
  color: #222222;
  margin-bottom: 16px;
}

.contact-desc {
  font-size: 16px;
  color: #595859;
  margin-bottom: 30px;
}

.primary-btn {
  padding: 14px 48px;
  background: #1763FF;
  color: #FFFFFF;
  border: none;
  border-radius: 4px;
  font-size: 18px;
  cursor: pointer;
  transition: background 0.3s;
}

.primary-btn:hover {
  background: #2E72FF;
}
</style>
